var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__second"},[_c('div',{staticClass:"container header__second-container"},[_c('SecondNavMenuL'),_c('SecondNavMenuR',{attrs:{"isFooter":true,"buttonOrder":['pay', 'price', ],"showAdditionalButton":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }